/**
 * @file Génère un schéma JSON-LD de type BreadcrumbList pour améliorer le SEO des pages du site web
 * @description Ce module permet de structurer les fils d’Ariane (breadcrumbs)
 *              selon les spécifications de Schema.org afin qu’ils soient reconnus par Google.
 * @author Roger Sioufi roger.sioufi[at]makeitbloom.com
 */

/**
 * Génère un schéma JSON-LD de type "BreadcrumbList" à partir d’un tableau de breadcrumb.
 *
 * @param locale - Code de langue (fr)
 * @param  breadcrumb - Tableau d’objets breadcrumb contenant des titres et des chemins
 * @returns {Object|null} Schéma JSON-LD ou null si le breadcrumb est invalide ou vide
 */
export function generateBreadcrumbSchema(locale, breadcrumb) {
    if (!Array.isArray(breadcrumb) || breadcrumb.length < 2) return null;

    const itemListElements = breadcrumb.map((item, index) => {
        const path = `/${locale}${item.attributes.path}`;
        const baseURL = 'https://longueuil.quebec';
        const fullUrl = new URL(path, baseURL).href;

        return {
            '@type': 'ListItem',
            position: index + 1,
            name: item.attributes.title,
            item: {
                '@type': 'WebPage',
                '@id': fullUrl,
            },
        };
    });

    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: itemListElements,
    };
}
